module.exports = __webpack_public_path__ + "static/media/developer-step3.99d87b58.png";